/* eslint-disable @typescript-eslint/no-namespace */
import { ICreateComment } from '../../../common/shared/interfaces/ICreateComment';
import { CreateReferral, Request } from '../../../common/shared/interfaces/IRequest';
import { PartialComment } from '../../../common/shared/types/PartialComment';
import { ReferralReassignmentPayload } from '../../../common/shared/forms/models/referral-reassignment.model';

export namespace NamRequests {
    export class create {
        public static readonly type = '[NAM Request Form] Create Request';
        constructor(
            public payload: Request,
            public comment?: ICreateComment
        ) {}
    }

    export class update {
        public static readonly type = '[NAM Request Form] Update Request';
        constructor(
            public id: string,
            public updates: Partial<Request>,
            public finishLoading = true
        ) {}
    }

    export class closeRequest {
        public static readonly type = '[NAM Request Form] Close Request';
        constructor(
            public comment: PartialComment,
            public classification?: string,
            public isSelfServiceOpportunity?: boolean
        ) {}
    }

    export class setQualityFlag {
        public static readonly type = '[NAM Request Form] Set Quality Flag';
        constructor(public id: string) {}
    }

    export class referOutRequest {
        public static readonly type = '[NAM Request Form] Refer Out Request';
        constructor(
            public payload: (Omit<CreateReferral, 'description'> & { comment: ICreateComment })[],
            public classificationUpdate?: { classification?: string; requestType?: string }
        ) {}
    }

    export class sendRequestBackToCril {
        public static readonly type = '[NAM Request Form] Send Request Back To CRIL';
        constructor(
            public referralId: string,
            public comment: PartialComment
        ) {}
    }

    export class closeReferral {
        public static readonly type = '[NAM Request Form] Close Referral';
        constructor(public referralId: string) {}
    }

    export class reassignReferral {
        public static readonly type = '[NAM Request Form] Reassign Referral';
        constructor(
            public referralId: string,
            public payload: ReferralReassignmentPayload
        ) {}
    }

    export class closeReferralsAndSetRequestUnderReview {
        public static readonly type = '[NAM Request Form] Close Referrals And Set Request Under Review';
    }
}
